/*----- Core -----*/
import styled from 'styled-components'

/*----- Commons -----*/
import Device			 from '../../commons/Device'
import Montserrat from '../../commons/mixins/fonts/Montserrat'

export default styled.main`

	display: flex;
  flex-direction: column;
	padding: 0 0 64px 0;

	.wellcome {
		padding-top: 65px;
		display: flex;
		align-items: center;
	}

	.wellcome-content {
		position: absolute;
		z-index: 3;
		max-width: 550px;
		padding: 16px;
		.default-button {
			margin-top: 42px;
		}
	}
	.wellcome-content__title {
		${ Montserrat(50, 600, 'white') };
		line-height: 56px;
	}
	.statement {
		position: relative;
		.statement__image-container > img {
			max-width: 400px;
			width: 100%;
		}
	}

	.statement_1 {
		.section-paragraph {
			background-color: white;
			z-index: 2;
			position: relative;
			border-radius: 6px 6px 0 0;
			padding: 16px;
		}
	}
	.statement_3 {
		.group {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			margin-bottom: 64px;
			.statement_3__people-image {
				max-width: 230px;
				width: 100%;
			}
			.default-button {
				margin-top: 32px;
			}
		}

	}
	.circle-and-lines {
		position: absolute;
		top: 0px;
		right: 0;
		width: 800px;
	}


	/*** START Nuestra Casa ***/
	.nuestra-casa__content {
		padding: 16px;
		max-width: 500px;
		.custom-paragraph {
			margin: 32px 0;
		}
	}
	.home-sentence {
		display: flex;
		justify-content: center;
		margin: 64px 0;
		padding: 0 16px;
		z-index: 3;
		p {
			${ Montserrat(18, 600, 'grey' ) };
			text-align: center;
			background: white;
			border-radius: 16px;
			max-width: 800px;
			padding: 32px;
		}
	}
	.our-home-video {
		margin-top: -160px;
	}
	.nuestra-casa {
		.nuestra-casa__logo {
			width: 250px;
		}
	}
	/*** END Nuestra Casa ***/

	@media ${ Device.lg } {
		.wellcome-content {
			margin-left: 128px;
			max-width: 700px;
		}
		.wellcome-content__title {
			${ Montserrat(70, 600, 'white') };
			line-height: 66px;
		}
		.person-slider-container {
			height: 300px;
		}
		.nuestra-casa__content {
			padding: 16px 64px;
		}
		.home-sentence {
			p {
			font-size: 26px;
			}
		}
	}
	
`